import Box from "@mui/material/Box";
import {useState} from "react";
import {ListItemButton, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

/**
 * Lets the user build a list of recipient e-mail addresses.
 *
 * @param callback - called with the updated list of addresses.
 * @param t - the caller's translation function, so the texts follow the caller's namespace.
 * @param initialRecipients - the addresses to start with, e.g. the caller's list when the field is shown again after a
 *                            failed share (DE-1723).
 */
export const AddEmailRecipients = ({callback, t, initialRecipients = []}) => {

    const [inputValue, setInputValue] = useState('');
    const [recipients, setRecipients] = useState(initialRecipients);

    const _handleAddClick = () => {
        const email = inputValue.trim();
        if (!isValidEmail(email) || recipients.includes(email)) return;

        const updated = [...recipients, email];
        setRecipients(updated);
        setInputValue('');
        callback(updated);
    };

    const _handleRemoveClick = (email) => {
        const updated = recipients.filter(r => r !== email);
        setRecipients(updated);
        callback(updated);
    };

    const _handleKeyDown = (e) => {
        if (e.key === 'Enter') _handleAddClick();
    };

    return <Box>
        <Stack direction="row" sx={{alignItems: "center"}}>
            <TextField
                helperText={t('shareNewRecipientHelp', 'Legg til e-mailadresse til mottagerne av delingen')}
                label={t('shareNewRecipientLabel', 'Ny mottager')}
                fullWidth
                margin="normal"
                value={inputValue}
                onChange={e => setInputValue(e.target.value)}
                onKeyDown={_handleKeyDown}
                error={inputValue.length > 0 && !isValidEmail(inputValue)}
            />
            <Button onClick={_handleAddClick} disabled={!isValidEmail(inputValue)}
                    aria-label={t('shareAddRecipient', 'Legg til mottager')}>
                <AddIcon/>
            </Button>
        </Stack>

        {recipients.length > 0 &&
            <List sx={{border: 'solid 1px #ddd'}}>
                {recipients.map(email => (
                    <ListItem key={email}>
                        <ListItemButton onClick={() => _handleRemoveClick(email)} sx={{width: 'auto', flexShrink: 0}}
                                        aria-label={t('shareRemoveRecipient', 'Fjern {{email}}', {email})}>
                            <DeleteIcon color="error"/>
                        </ListItemButton>
                        <ListItemText primary={email}/>
                    </ListItem>
                ))}
            </List>
        }
    </Box>;
};